import { Routes } from '@angular/router';

// Guards
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';

// Pages
import { AuthPage } from '@pages/auth/auth';
import { AppPage } from '@pages/app/app';
import { CmsPage } from '@pages/cms/cms';

// Components
import { AppLogin } from '@components/app/login/login';
import { AppRegister } from '@components/app/register/register';
import { AppForgotPassword } from '@components/app/forgot-password/forgot-password';
import { AppUnsubscribe } from '@components/app/unsubscribe/unsubscribe';
import { ClubECard } from '@components/club/ecard/ecard';
import { MyapLivekitJoin } from '@components/myap/livekit/join/join';

export const routes: Routes = [
	{ path: '', component: AppPage, canActivate: [authGuard] },
	{ path: 'home', component: CmsPage },
	{
		path: '',
		component: AuthPage,
		children: [
			{ path: 'login', component: AppLogin, canActivate: [guestGuard] },
			{ path: 'public/register', component: AppRegister },
			{ path: 'public/forgot-password', component: AppForgotPassword },
			{ path: 'public/unsubscribe', component: AppUnsubscribe },
			{ path: 'public/ecard', component: ClubECard },
			{ path: 'public/livekit', component: MyapLivekitJoin },
		],
	},
	{ path: '**', redirectTo: '' },
];
